// Used to configure the default colors and styling of Material UI
import { createTheme } from '@mui/material';

import colors from '@atom/styles/colors';

export const muiTheme = createTheme({
  typography: {
    fontFamily: 'Roboto, sans-serif',
  },
  palette: {
    primary: {
      main: colors.brand.blue,
    },
    text: {
      primary: colors.neutral.dark,
    },
  },
  components: {
    // @ts-ignore
    MuiPickersInputBase: {
      styleOverrides: {
        sectionsContainer: {
          // Override to remove the minimum width for MUI X Date Pickers
          width: 0,
        },
      },
    },
  },
});
